webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cell',
  props: ['isSelected', 'isBlank', 'className', 'lineClass', 'isLine'],
  computed: {
    classNames: function classNames() {
      return {
        'selected': this.isSelected,
        'blank': this.isBlank };
    }
  }
});

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cell__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__themes__ = __webpack_require__(97);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'game',
  components: {
    cell: __WEBPACK_IMPORTED_MODULE_3__cell___default.a
  },
  data: function data() {
    return {
      cellData: [],
      currentSelect: null,
      config: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */]) };
  },

  computed: {
    currentTheme: function currentTheme() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_6__themes__["a" /* default */].filter(function (e) {
        return e.name === _this.config.defaultTheme;
      })[0];
    }
  },
  mounted: function mounted() {
    this.init();
  },

  methods: {
    init: function init() {
      console.time('initData');
      this.cellData = this.initData();
      console.timeEnd('initData');
    },
    initData: function initData() {
      var cellGroup = this.currentTheme.classNames.map(function (e) {
        return {
          isBlank: false,
          className: e,
          lineClass: '',
          isLine: false,
          isSelected: false
        };
      });

      var blankCell = {
        isBlank: true,
        className: '',
        lineClass: '',
        isLine: false,
        isSelected: false
      };

      var randomCellGroup = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].arrayRandom(cellGroup, this.config.cellGroupCount);

      var cellData = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].arrayFillByRandomGroup(this.config.row * this.config.col, randomCellGroup);

      var result = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].dyadicArrayWrap(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].arrayToDyadic(cellData, this.config.col), blankCell);

      result.forEach(function (cols, row) {
        cols.forEach(function (cell, col) {
          cell.row = row;
          cell.col = col;
        });
      });
      return result;
    },
    handleClick: function handleClick(ev) {
      if (ev.target.nodeName !== 'TD') return;

      var col = ev.target.cellIndex;
      var row = ev.target.parentNode.rowIndex;
      var currentCell = this.cellData[row][col];
      if (currentCell.isBlank === true) return;

      this.selectCell(currentCell);
      this.$forceUpdate();
    },
    selectCell: function selectCell(currCell) {
      if (!this.currentSelect) {
        currCell.isSelected = true;
        this.currentSelect = currCell;
        return;
      }
      if (this.currentSelect === currCell) {
        currCell.isSelected = false;
        this.currentSelect = null;
        return;
      }

      var prevCell = this.currentSelect;

      if (prevCell.className !== currCell.className) {
        prevCell.isSelected = false;
        currCell.isSelected = true;
        this.currentSelect = currCell;
        return;
      }

      console.time('getLine');
      var result = this.getLine(prevCell, currCell);
      console.timeEnd('getLine');

      if (result.length === 0) {
        prevCell.isSelected = false;
        currCell.isSelected = true;
        this.currentSelect = currCell;
      } else {
        prevCell.isBlank = true;
        currCell.isBlank = true;
        prevCell.className = '';
        currCell.className = '';
        prevCell.isSelected = false;
        currCell.isSelected = false;

        this.currentSelect = null;

        this.drawLine(result);
      }
    },
    drawLine: function drawLine(line) {
      var _this2 = this;

      line.forEach(function (e, i) {
        e.isLine = true;

        e.lineClass = _this2.addLineClass(line[i - 1], e, line[i + 1]);
      });

      setTimeout(function () {
        _this2.hideLine(line);
      }, this.config.lineDelay);
    },
    hideLine: function hideLine(line) {
      line.forEach(function (e, i) {
        e.isLine = false;
        e.lineClass = '';
      });
    },
    addLineClass: function addLineClass(prev, curr, next) {
      var result = void 0;
      if (!prev) {
        result = 'line-start line-' + this.getDirection(curr, next);
      } else if (!next) {
        result = 'line-end line-' + this.getDirection(curr, prev);
      } else {
        result = 'line-' + this.getDirection(curr, prev) + ' line-' + this.getDirection(curr, next);
      }
      return 'line ' + result;
    },
    getDirection: function getDirection(curr, next) {
      return curr.row === next.row ? curr.col > next.col ? 'l' : 'r' : curr.row > next.row ? 't' : 'b';
    },
    getLine: function getLine(prev, curr) {
      var result = [];

      var prevH = this.getHorizontalLine(prev);
      if (prevH.has(curr)) return this.getBeeline(prev, curr);
      var prevV = this.getVerticalLine(prev);
      if (prevV.has(curr)) return this.getBeeline(prev, curr);

      var currH = this.getHorizontalLine(curr);
      var currV = this.getVerticalLine(curr);

      if (!prevH.size && !prevV.size || !currH.size && !currV.size) return result;

      var intersection = this.getIntersection(prevH, currV) || this.getIntersection(prevV, currH);

      if (intersection) return this.getBeeline(prev, intersection).concat(this.getBeeline(intersection, curr).slice(1));

      var intersectionArr = this.getIntersectionArr(prevH, currH, prev.row, curr.row, true);
      if (intersectionArr.length === 0) {
        intersectionArr = this.getIntersectionArr(prevV, currV, prev.col, curr.col, false);
      }

      if (intersectionArr.length > 0) {
        result = this.getBeeline(prev, intersectionArr[0]).concat(this.getBeeline(intersectionArr[0], intersectionArr[1]).slice(1)).concat(this.getBeeline(intersectionArr[1], curr).slice(1));
      }

      return result;
    },
    getIntersection: function getIntersection(prevLine, currLine) {
      var intersection = null;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(prevLine), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _cell = _step.value;

          if (currLine.has(_cell) && _cell.isBlank) {
            intersection = _cell;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return intersection;
    },
    getIntersectionArr: function getIntersectionArr(prev, curr, prevIndex, currIndex, isRow) {
      var result = [];
      if (!prev.size || !curr.size) {
        return result;
      }

      var rowKey = isRow ? 'col' : 'row';
      var prevFullLine = isRow ? this.cellData[prevIndex] : this.cellData.map(function (e) {
        return e[prevIndex];
      });
      var currFullLine = isRow ? this.cellData[currIndex] : this.cellData.map(function (e) {
        return e[currIndex];
      });

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(prev), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var prevCell = _step2.value;

          if (!prevCell.isBlank) continue;

          var target = currFullLine[prevCell[rowKey]];

          if (curr.has(target)) {
            var index = target[rowKey];

            var isBeeline = this.checkBeeline(prevFullLine[index], currFullLine[index]);
            if (isBeeline) {
              result = [prevFullLine[index], currFullLine[index]];
              break;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return result;
    },
    checkBeeline: function checkBeeline(start, end) {
      var result = true;

      var beeline = this.getBeeline(start, end);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(beeline), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var lineCell = _step3.value;

          if (!lineCell.isBlank) {
            result = false;
            break;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return result;
    },
    getBeeline: function getBeeline(start, end) {
      var startIndex = void 0;
      var endIndex = void 0;
      var arr = void 0;
      if (start.row === end.row) {
        startIndex = start.col;
        endIndex = end.col;
        arr = this.cellData[start.row];
      } else {
        startIndex = start.row;
        endIndex = end.row;
        arr = this.cellData.map(function (e) {
          return e[start.col];
        });
      }

      return startIndex < endIndex ? arr.slice(startIndex, endIndex + 1) : arr.slice(endIndex, startIndex + 1).reverse();
    },
    getHorizontalLine: function getHorizontalLine(curr) {
      return this.checkCell(this.cellData[curr.row], curr.col);
    },
    getVerticalLine: function getVerticalLine(curr) {
      return this.checkCell(this.cellData.map(function (e) {
        return e[curr.col];
      }), curr.row);
    },
    checkCell: function checkCell(arr, index) {
      var set = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();

      for (var i = index - 1; i >= 0; i--) {
        var _cell2 = arr[i];

        if (_cell2.className === arr[index].className || _cell2.isBlank) {
          set.add(_cell2);
        }

        if (!_cell2.isBlank) {
          break;
        }
      }

      for (var _i = index + 1, l = arr.length; _i < l; _i++) {
        var _cell3 = arr[_i];
        if (_cell3.className === arr[index].className || _cell3.isBlank) {
          set.add(_cell3);
        }
        if (!_cell3.isBlank) {
          break;
        }
      }
      return set;
    }
  }
});

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(48),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(50),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(52)

var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(49),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('game')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.currentTheme.name
  }, [_c('div', {
    staticClass: "game-config"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.init
    }
  }, [_vm._v("重新开始")])]), _vm._v(" "), _c('table', {
    staticClass: "game",
    on: {
      "click": _vm.handleClick
    }
  }, _vm._l((_vm.cellData), function(cols, row) {
    return _c('tr', {
      key: row
    }, _vm._l((cols), function(cell, col) {
      return _c('cell', {
        key: col,
        attrs: {
          "isSelected": cell.isSelected,
          "isLine": cell.isLine,
          "lineClass": cell.lineClass,
          "isBlank": cell.isBlank,
          "className": cell.className
        }
      })
    }))
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    class: _vm.classNames
  }, [(_vm.isLine) ? _c('div', {
    class: _vm.lineClass
  }) : _vm._e(), _vm._v("\n  " + _vm._s(_vm.className) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  defaultTheme: 'test',
  cellGroupCount: 9,
  col: 10,
  row: 10,
  lineDelay: 500
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

var themes = [{
  name: 'test',
  classNames: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()('123456789')
}];
/* harmony default export */ __webpack_exports__["a"] = (themes);

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


var Utils = {};

if (!Array.prototype.fill) {
  Object.defineProperty(Array.prototype, 'fill', {
    value: function value(_value) {
      if (this == null) {
        throw new TypeError('this is null or not defined');
      }

      var O = Object(this);

      var len = O.length >>> 0;

      var start = arguments[1];
      var relativeStart = start >> 0;

      var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);

      var end = arguments[2];
      var relativeEnd = end === undefined ? len : end >> 0;

      var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);

      while (k < final) {
        O[k] = _value;
        k++;
      }

      return O;
    }
  });
}


Utils.dyadicArrayWrap = function (arr, fill) {
  var firstRowLength = 0;
  var lastRowLength = 0;
  arr.forEach(function (row, index) {
    if (index === 0) {
      firstRowLength = row.length + 2;
    } else if (index === arr.length - 1) {
      lastRowLength = row.length + 2;
    }
    row.splice(0, 0, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, fill).valueOf());
    row.splice(row.length, 0, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, fill).valueOf());
  });
  arr.splice(0, 0, Array(firstRowLength).fill(0).map(function (e) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, fill).valueOf();
  }));
  arr.splice(arr.length, 0, Array(lastRowLength).fill(0).map(function (e) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, fill).valueOf();
  }));
  return arr;
};

var arrayRandomItem = function arrayRandomItem(arr, set) {
  var arrlen = arr.length;
  var rand = ~~(Math.random() * arrlen);
  return set.has(rand) ? arrayRandomItem(arr, set) : (set.add(rand), arr[rand]);
};

Utils.arrayRandom = function (arr, count) {
  if (arr.length <= count) {
    Utils.arrayShuffle(arr);
    return arr;
  }
  var set = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
  return Array(count).fill(0).map(function (e) {
    return arrayRandomItem(arr, set);
  });
};

Utils.arrayShuffle = function (arr) {
  for (var j, x, i = arr.length; i; j = ~~(Math.random() * i), x = arr[--i], arr[i] = arr[j], arr[j] = x) {}
  return arr;
};

Utils.arrayFillByRandomGroup = function (fillCount, group) {
  var groupCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  var groupLength = group.length;
  var perGroup = ~~(~~(fillCount / groupLength) / groupCount) * groupCount;
  var rest = fillCount - perGroup * groupLength;
  var countArray = group.map(function (e, i) {
    return rest / groupCount > i ? perGroup + groupCount : perGroup;
  });
  var result = countArray.reduce(function (prev, curr, index) {
    return prev.concat(Array(curr).fill(0).map(function (e) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, group[index]).valueOf();
    }));
  }, []);
  Utils.arrayShuffle(result);
  return result;
};

Utils.arrayToDyadic = function (arr, col) {
  var result = [];
  arr.forEach(function (e, i) {
    var index = ~~(i / col);
    var mod = i % col;
    result[index] || (result[index] = []);
    result[index][mod] = e;
  });
  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (Utils);

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_game__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_game__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    game: __WEBPACK_IMPORTED_MODULE_0__components_game___default.a
  }
});

/***/ })

},[96]);


// WEBPACK FOOTER //
// static/js/app.c64a107335a1346467b0.js